import axios      from "axios";
import axiosRetry from "axios-retry";

export const ApiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE,
  headers: {
    "Content-Type": "application/json"
  },
  withCredentials: true
});

axiosRetry(ApiClient, {
  retries: 3,
  retryCondition: error => error.code === "400" || error.code === "500"
});
